{
  "fr": {
    "datatable": {
      "actions": {
        "bulk_action": "Action en masse",
        "bulk_edit": "Modification en masse",
        "clear": "Effacer",
        "clear_filters": "Effacer les filtres",
        "collapse_all": "Tout réduire",
        "deselect_all": "Tout désélectionner",
        "expand_all": "Tout développer",
        "select_all": "Tout sélectionner"
      },
      "import": {
        "error_row": "Ligne {row}",
        "errors_description": "L'import a été annulé car {count} ligne(s) contenaient des erreurs. Aucun enregistrement n'a été importé.",
        "errors_title": "Échec de l'import",
        "success": "Fichier importé avec succès",
        "title": "Importer"
      },
      "labels": {
        "freeze_columns": "Figer les colonnes",
        "freeze_rows": "Figer les lignes",
        "gridlines": "Quadrillage",
        "group_by": "Regrouper par",
        "size": "Taille",
        "sticky_headers": "En-têtes fixes",
        "striped_rows": "Lignes zébrées",
        "toggle_columns": "Basculer les colonnes"
      }
    }
  }
}
